import { ReactNode } from 'react';

import { Role } from '../types';
import { useAuthContext } from '../hooks';

interface Option {
  roles: string[];
  component: ReactNode;
}

interface RoleBoundaryProps {
  options: Option[];
  fallback?: ReactNode;
}

/**
 * Used to render different components depending on the user's roles
 * @param options: a list of options mapping roles to a specified component
 * @param fallback: an optional fallback component
 * @returns
 */
export default function RoleSwitch({ options, fallback = null }: RoleBoundaryProps) {
  const { user } = useAuthContext();

  for (let index = 0; index < options.length; index += 1) {
    if (user?.roles?.some((userRole: Role) => options[index].roles.includes(userRole.name))) {
      return options[index].component;
    }
  }

  return fallback ?? null;
}
